import { defineComponent as _defineComponent } from 'vue'
import { RealtimeReportService, SelectOptionsService, toastServiceError } from '@/services';
import store from '@/store';
import {
    AgentExtensionReportActions,
    AgentExtensionReportFilter,
    AgentExtensionReportGetters,
    MultiSelectOption,
    SelectOptionsServiceGetQueuesResult,
    SelectOptionsServiceGetUserLabelsResult,
    SelectOptionsServiceGetUsersResult,
    UserDeviceStatus,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';
import { computed, onMounted, Ref, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentExtensionReportFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const defaultFilter = computed(() => store.getters[AgentExtensionReportGetters.DEFAULT_FILTER]);
const storeFilter = computed(() => store.getters[AgentExtensionReportGetters.FILTER]);

const filterOpened = ref(false);

const filter: Ref<AgentExtensionReportFilter> = ref({
    status: defaultFilter.value.status,
    user: defaultFilter.value.user,
    userLabel: defaultFilter.value.userLabel,
    queue: defaultFilter.value.queue,
});

// Options
const userOptions: Ref<SelectOptionsServiceGetUsersResult[]> = ref([]);
const userLabelOptions: Ref<SelectOptionsServiceGetUserLabelsResult[]> = ref([]);
const queueOptions: Ref<SelectOptionsServiceGetQueuesResult[]> = ref([]);
const statusOptions: Ref<MultiSelectOption[]> = ref([
    {
        value: UserDeviceStatus.CONNECTED,
        label: t('report.realtimeAgentExtension.device.status.CONNECTED'),
    },
    {
        value: UserDeviceStatus.OFFLINE,
        label: t('report.realtimeAgentExtension.device.status.OFFLINE'),
    },
    {
        value: UserDeviceStatus.IN_PAUSE,
        label: t('report.realtimeAgentExtension.device.status.IN_PAUSE'),
    },
]);

watch(filterOpened, () => {
    refreshLocalFilter();
});

const fetchUsers = async () => {
    try {
        const response = await RealtimeReportService.getUserDevices();
        const users = new Map<number, SelectOptionsServiceGetUsersResult>();
        for (const userDevice of response.data) {
            const user = userDevice.user;
            const extensionNumber = user.extension?.number;

            if (extensionNumber === undefined) continue;

            if (!users.has(extensionNumber)) {
                users.set(extensionNumber, {
                    id: extensionNumber,
                    name: user.name,
                    labels: [],
                });
            }
        }
        userOptions.value = Array.from(users.values());
    } catch (error) {
        toastServiceError(error);
    }
};

const fetchUserLabels = async () => {
    try {
        const response = await SelectOptionsService.getUserLabels();
        userLabelOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const fetchQueues = async () => {
    try {
        const response = await SelectOptionsService.getQueues();
        queueOptions.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    store.dispatch(AgentExtensionReportActions.SET_FILTER, filter.value);
};

const clearFilters = () => {
    store.dispatch(AgentExtensionReportActions.CLEAR_FILTER);
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filter.value.status = storeFilter.value.status;
    filter.value.user = storeFilter.value.user;
    filter.value.userLabel = storeFilter.value.userLabel;
    filter.value.queue = storeFilter.value.queue;
};

onMounted(() => {
    fetchUsers();
    fetchUserLabels();
    fetchQueues();
});

const __returned__ = { t, defaultFilter, storeFilter, filterOpened, filter, userOptions, userLabelOptions, queueOptions, statusOptions, fetchUsers, fetchUserLabels, fetchQueues, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})